import { DS_REQUEST_BRIEF_CREATE_URL } from '@99designs/i18n';
import { Tier, TierLocale, generateTiers } from './tierConfig';

export type MpvId =
    | 'standardbusinesscards'
    | 'flyersandleaflets'
    | 'postcards'
    | 'bifoldbrochures'
    | 'vinylbanners'
    | 'retractablebanners'
    | 'bellacanvasunisexshortsleevejerseytshirtdtg2go'
    | 'posters'
    | 'flyers';

export type Product = {
    mpvId: MpvId;
    getTiers: (locale: TierLocale, options?: { useExperimentVariants?: boolean }) => Tier[];
};

export const productConfig: Record<MpvId, Product> = {
    standardbusinesscards: {
        mpvId: 'standardbusinesscards',
        getTiers: (locale, options): Tier[] =>
            generateTiers('standardbusinesscards', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=premiumbusinesscarddesign&mpvId=standardbusinesscards`,
                    },
                },
            }),
    },
    postcards: {
        mpvId: 'postcards',
        getTiers: (locale, options): Tier[] =>
            generateTiers('postcards', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=exclusivepostcarddesign&mpvId=postcards`,
                    },
                },
            }),
    },
    bifoldbrochures: {
        mpvId: 'bifoldbrochures',
        getTiers: (locale, options): Tier[] =>
            generateTiers('bifoldbrochures', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=exclusivebifoldbrochuredesign&mpvId=bifoldbrochures`,
                    },
                },
            }),
    },
    vinylbanners: {
        mpvId: 'vinylbanners',
        getTiers: (locale, options): Tier[] =>
            generateTiers('vinylbanners', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=exclusivevinylbannerdesign&mpvId=vinylbanners`,
                    },
                },
            }),
    },
    retractablebanners: {
        mpvId: 'retractablebanners',
        getTiers: (locale, options): Tier[] =>
            generateTiers('retractablebanners', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=exclusiveretractablebannerdesign&mpvId=retractablebanners`,
                    },
                },
            }),
    },
    bellacanvasunisexshortsleevejerseytshirtdtg2go: {
        mpvId: 'bellacanvasunisexshortsleevejerseytshirtdtg2go',
        getTiers: (locale, options): Tier[] =>
            generateTiers('bellacanvasunisexshortsleevejerseytshirtdtg2go', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=exclusivetshirtdesign&mpvId=bellacanvasunisexshortsleevejerseytshirtdtg2go`,
                    },
                },
            }),
    },
    posters: {
        mpvId: 'posters',
        getTiers: (locale, options): Tier[] =>
            generateTiers('posters', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=exclusiveposterdesign&mpvId=posters`,
                    },
                },
            }),
    },
    flyers: {
        mpvId: 'flyers',
        getTiers: (locale, options): Tier[] =>
            generateTiers('flyers', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=exclusiveflyerdesign&mpvId=flyers`,
                    },
                },
            }),
    },
    // EN-AU only
    flyersandleaflets: {
        mpvId: 'flyersandleaflets',
        getTiers: (locale, options): Tier[] =>
            generateTiers('flyersandleaflets', locale, {
                useExperimentVariants: options?.useExperimentVariants,
                overrides: {
                    exclusiveDesign: {
                        briefURL: `${DS_REQUEST_BRIEF_CREATE_URL}?locale=${locale}&esmpvid=premiumflyerdesign&mpvId=flyersandleaflets`,
                    },
                },
            }),
    },
};
